module.exports = __webpack_public_path__ + "img/action-2.02aa8bbb.svg";